import { render, staticRenderFns } from "./HomeworkPlaning.vue?vue&type=template&id=a2ac62d4&scoped=true"
import script from "./HomeworkPlaning.vue?vue&type=script&lang=js"
export * from "./HomeworkPlaning.vue?vue&type=script&lang=js"
import style0 from "./HomeworkPlaning.vue?vue&type=style&index=0&id=a2ac62d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ac62d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2ac62d4')) {
      api.createRecord('a2ac62d4', component.options)
    } else {
      api.reload('a2ac62d4', component.options)
    }
    module.hot.accept("./HomeworkPlaning.vue?vue&type=template&id=a2ac62d4&scoped=true", function () {
      api.rerender('a2ac62d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/homework/HomeworkPlaning.vue"
export default component.exports